import { buildProperty } from "@firecms/core";
import { buildLocalizedStringProperty } from "../localization";

export const codeProperty = buildProperty({
    name: "Code",
    validation: { required: true },
    dataType: "string",
});

export const titleProperty = buildLocalizedStringProperty({
    name: "Title",
    dataType: "string",
    validation: { required: true },
});

export const bodyProperty = buildLocalizedStringProperty({
    name: "Body",
    dataType: "string",
    markdown: true,
    description:
        "Main text participants read inside the app (supports formatting).",
    validation: { required: true },
    hideFromCollection: true,
});

export const questionProperty = buildLocalizedStringProperty({
    name: "Question",
    dataType: "string",
    multiline: true,
    validation: { required: true },
});

export const questionHintProperty = buildLocalizedStringProperty({
    name: "Hint",
    description:
        "Optional coaching text for the Helper role in cooperative play (not shown to the Responder). May strongly nudge toward the concept; avoid quoting a single option verbatim.",
    dataType: "string",
    multiline: true,
    validation: { required: false },
});

export const feedbackCorrectProperty = buildLocalizedStringProperty({
    name: "Feedback (correct)",
    dataType: "string",
    multiline: true,
    validation: { required: true },
});

export const feedbackIncorrectProperty = buildLocalizedStringProperty({
    name: "Feedback (incorrect)",
    dataType: "string",
    multiline: true,
    validation: { required: true },
});

export const questionOptionTextProperty = buildLocalizedStringProperty({
    name: "Text",
    dataType: "string",
    validation: { required: true },
});


